import api from "../../axiosConfig";

export const addreceptionist = async (formData) => {
    const token= sessionStorage.getItem('token');
    try {

      const response = await api.post('/receptionist/add-receptionist', formData);
      const resData = response?.data;
      console.log('Response data:', resData);
  
      if (resData?.success_type === 'success'|| resData?.message_type === 'success') {
        return { success: true, data: resData };
      } else {
        return { success: false, error: resData.message };
      }
    } catch (err) {
      throw new Error(err.response?.data?.message || 'Login error');
    }
  };


export const getReceptionist = async () => {
  const token = sessionStorage.getItem('token');

  try {
    const response = await api.get('/receptionist/all-receptionist', {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });

    const resData = response?.data;
    console.log('Response data:', resData);

    if (resData?.success_type === 'success'|| resData?.message_type === 'success') {
      return { success: true, data: resData?.data };
    } else {
      return { success: false, error: resData.message };
    }
  } catch (err) {
    throw new Error(err.response?.data?.message || 'Error fetching receptionist');
  }
};

export const updatereceptionist = async (id, formData) => {
  const token = sessionStorage.getItem('token');

  // Append required format values
  const payload = {
    ...formData,
    id: parseInt(id),
    _method: 'put', // Required for Laravel-style method spoofing
  };
  console.log('Payload for update:', payload);

  try {
    const response = await api.post(`receptionist/update-receptionist/${id}`, payload
    );

    const resData = response?.data;
    console.log('Update receptionist response:', resData);

    if (resData?.success_type === 'success'|| resData?.message_type === 'success') {
      return { success: true, data: resData };
    } else {
      return { success: false, error: resData.message };
    }
  } catch (err) {
    throw new Error(err.response?.data?.message || 'Error updating receptionist');
  }
};